import { render, staticRenderFns } from "./pick-year.vue?vue&type=template&id=0f8e54ee&"
import script from "./pick-year.vue?vue&type=script&lang=js&"
export * from "./pick-year.vue?vue&type=script&lang=js&"
import style0 from "./pick-year.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports